import React, { useState } from 'react'
import DxDataTable from 'components/DxDataTable'
import { useTranslation } from 'react-i18next'
import { Modal } from 'components/Modal'
import { useQuery } from 'components/graphql'
import { DateTimePicker } from 'components/forms'

import gql from 'graphql-tag'

const query = gql`
	query listLoyaltyCardPointsByDay($params: ListQueryArgs!, $day: Date!) {
	  cashAssist {
			listLoyaltyCardPointsByDay(
		      day: $day
		      params: $params
	    	) {
		        id
		        name
		        points
		        balance
		        isActive
	    	}
	  	}
	}
`

const DatPoints = props => {
	const [day, setDay] = useState(new Date())
	const [t] = useTranslation()
	const { data, loading } = useQuery(query, {
		variables: { day: new Date(day).toISOString().split('T')[0], params: { } }
	})

	return(
		<Modal {...props} width={600} label={t('loyalty_card_section.strings.balancePerDay')}>
			<DateTimePicker noForm picker='date' value={day} onChange={setDay}/>
			<DxDataTable
				excelExport
				isLoading={loading}
				data={data.listLoyaltyCardPointsByDay}
				scrolling={{
					mode: 'infinite'
				}}
				paging={{
					enabled: true,
					pageSize: 100
				}}
				columns={[{
					caption: t('common.fields.code'),
					dataField: 'id'
				}, {
					caption: t('loyalty_card_section.fields.card_name'),
					dataField: 'name'
				}, {
					caption: t('loyalty_card_section.fields.points'),
					dataField: 'points',
					summary: {
						summaryType: 'sum'
					},
					localFormat: { type: 'float', precision: 2 }
				}, {
					caption: t('loyalty_card_section.strings.balance'),
					dataField: 'balance',
					summary: {
						summaryType: 'sum'
					},
					localFormat: { type: 'float', precision: 2 }
				}, {
					caption: t('common.fields.isActive'),
					dataField: 'isActive'
				}]}
				label={t('common.strings.preview')}
				height={480}
				withSearch
			/>
		</Modal>
	)
}

export default DatPoints
